// Admin copy of the web app's src/device/deviceAxios.js (card 540f21a4); keep the two in step.
// Device mode for the app's API calls (card 540f21a4). On a paired event-day
// device every call to the API goes to the device API instead: `${BASE}/x`
// becomes `${BASE}/job/x`, and the device's token replaces the sign-in token.
// The screens themselves don't change; the server decides what the device's
// job may do (and answers 404 JOB_ROUTE_UNAVAILABLE for anything else).
import axios from 'axios';
import { deviceToken } from './deviceSession';

const base = () => String(process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '');

// The device API address for an API URL, or null when the URL isn't the API's
// (or is already a device or pairing call).
export function deviceUrl(url, apiBase = base()) {
  const u = String(url || '');
  if (!apiBase || !u.startsWith(`${apiBase}/`)) return null;
  const rest = u.slice(apiBase.length);
  if (/^\/(job|device-pair)(\/|$|\?)/.test(rest)) return null;
  return `${apiBase}/job${rest}`;
}

function setHeader(headers, name, value) {
  if (!headers) return;
  if (typeof headers.set === 'function') headers.set(name, value);
  else headers[name] = value;
}
function dropHeader(headers, name) {
  if (!headers) return;
  if (typeof headers.delete === 'function') headers.delete(name);
  else delete headers[name];
}

export function rewriteForDevice(config, token = deviceToken()) {
  if (!token) return config;
  const url = deviceUrl(config.url);
  if (!url) return config;
  config.url = url;
  config.headers = config.headers || {};
  dropHeader(config.headers, 'accesstoken');
  setHeader(config.headers, 'x-job-token', token);
  return config;
}

let installed = null;
// Once per client; harmless to call again.
export function installDeviceInterceptor(client = axios) {
  if (installed === client) return;
  client.interceptors.request.use((config) => rewriteForDevice(config));
  installed = client;
}
